var _g, _g2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFleche(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 36,
    viewBox: "0 0 21 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L10.5 9.6V16L0 6.4V0Z",
    fill: "#00FF79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 0L10.5 9.6V16L21 6.4V0Z",
    fill: "#00FF79"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10L10.5 19.6V26L0 16.4V10Z",
    fill: "#00FF79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10L10.5 19.6V26L21 16.4V10Z",
    fill: "#00FF79"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20L10.5 29.6V36L0 26.4V20Z",
    fill: "#00FF79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20L10.5 29.6V36L21 26.4V20Z",
    fill: "#00FF79"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleche);
export default __webpack_public_path__ + "static/media/Fleche.b753eb7b275478c19a6c2de639d28a10.svg";
export { ForwardRef as ReactComponent };